export const TYPE = {
    ORDER_LIST: 'ORDER_LIST',
    SET_LOADER: 'SET_LOADER'
}